import React from 'react'
import { Container } from 'semantic-ui-react';
import { Grid } from 'semantic-ui-react';
import { NavLink } from 'react-router-dom';
import { useSelector} from 'react-redux';
import { db } from "../../../firebase";
import axios from "axios";
import useGlobalConfig from '../../../hooks/globalConfig';
import { CircularProgress } from '@mui/material';
const Billing = (props) => {
    const {siteName} = useGlobalConfig()
    const userUid = useSelector(store => store.usuario.user.uid);
   // // console.log(props)
    // console.log(userUid)
    const [session, setSession] = React.useState("")
    const [assignCompany,setAssignCompany]= React.useState("")
    const [dataCompany,setDataCompany] = React.useState("")
    const {purchaseState} = useGlobalConfig()
    const [autorize,setAutorize]= React.useState(null)


        React.useEffect(() => {
            if (userUid) {
              obtenerDatosdeCliente(userUid);
              
            }
          }, []);   

          React.useEffect(() => {
            if (session.userCompanyID) {
            if(session.roll === 'biccixpressAdmin'){ 
                getData('getAll',session.userCompanyID)
                setAutorize(true)
            }else{
                getData('getDat',session.userCompanyID)
                setAutorize(null)
            }
            }
          }, [session]);   

      const obtenerDatosdeCliente = async (userUid) => {
            try {
            const accountants = await db.collection(`${process.env.REACT_APP_COL_USERS}`).doc(userUid).get();
            var data = accountants.data();
            setSession(data);
            const companiesaccountants = await db
                .collection(`${process.env.REACT_APP_COL_COMPANIES}`)
                .doc(data.userCompanyID)
                .get();
            var dataComp = companiesaccountants.data();
            //// console.log(dataComp);
            if (dataComp) {
                setAssignCompany(dataComp);
            } else {
                setAssignCompany("");
            }
            } catch (error) {}
        };

        const getData = async (method, userCompanyID) =>{
          
            const company = {
                method:method,
                companyId:userCompanyID,
                documentId:'20'
            }
      
            const response = await axios.post('http://localhost:5000/bicci-dev-c842f/us-central1/billincompany/', company, {      // Desarrollo
                headers: {
                  'Content-Type': 'application/json' 
                  }
                }); 
            // console.log('Respuesta')  
            setDataCompany(response.data)  
            // console.log(response)

        }



        // console.log(session)
        // console.log(assignCompany)

  return (
    <div className="bg-container">
        <Grid celled='internally'  id='mi-cuentaContent'>
        <div><h2> Facturación {siteName}</h2></div>
        <Grid.Row> 
        <table className="table">
                            <thead>
                            <tr>
                            <th scope="col">Código</th>
                            <th scope="col">Cliente</th>
                            <th scope="col">Fecha de Compra</th>
                            <th scope="col">Total</th>
                            <th scope="col">Status</th>
                            <th scope="col">Acción</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                              dataCompany?(<>

                              {dataCompany.map((element) => ( 
                                    <tr key={element.buyOrderId}> 
                                    <td >{element.buyOrderId}</td>
                                    <td >{element.BillingClientCompany}</td>
                                    <td >{element.createdateAdd}</td>
                                    <td >{element.paidAmount}</td>
                                    <td >{purchaseState[element.purchaseState]}</td>
                                    <td >
                                    <NavLink className="btn btn-buy  m-1" to={`/billing/${element.companyUid}/${element.buyOrderId}`}  color="primary" variant="contained"> VER </NavLink>

                                    <NavLink className="btn btn-buy  m-1" to={`/billing/validacion/${element.companyUid}/${element.buyOrderId}`}  color="primary" variant="contained"> Validar Pago </NavLink>
                                    
                                    </td>
                                  
                                    </tr>
                                    ))                          
                                  } 

                              </>):(<><tr><td>Sin resultados</td></tr></>)
                            }
                         

                            </tbody>
         </table>
        </Grid.Row> 
        </Grid>
    </div>
  )
}

export default Billing